// eslint-disable-next-line no-unused-vars
/* eslint-disable no-unused-vars */
import React, { forwardRef } from "react";
import { Box } from "@material-ui/core";
import DatePicker from "react-datepicker";
import PropTypes from "prop-types";
import "react-datepicker/dist/react-datepicker.css";
import format from "date-fns/format";
import { useDispatch, useSelector } from "react-redux";
import { selectDateFilter } from "../../redux/selectors/dateFilterSelector";
import { getEndOfDay, getStartOfDay } from "../../utils/utils";
import { setDateRange } from "../../redux/features/dateFilter/action";

const CustomDate = forwardRef(
  ({ value, onClick, className, startDate, endDate }, ref) => (
    <div
      ref={ref}
      className={className}
      role="button"
      tabIndex={0}
      onClick={onClick}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") onClick();
      }}
      style={{
        display: "flex",
        alignItems: "center",
        gap: "4px",
      }}
    >
      <strong>
        {startDate
          ? format(startDate, "dd MMM yyyy")
          : format(new Date(), "dd MMM yyyy")}{" "}
      </strong>
      to
      <strong>
        {endDate
          ? format(endDate, "dd MMM yyyy")
          : "--"}
      </strong>
      <div
        style={{
          cursor: "pointer",
          padding: "2px",
          textDecoration: "underline",
          color: "#007bff",
        }}
      >
        Change Date
      </div>
    </div>
  )
);

const CustomDateInput = () => {
  const { startDate, endDate } = useSelector(selectDateFilter);
  const dispatch = useDispatch();

const handleDateChange = (dates) => {
  if (Array.isArray(dates) && dates.length === 2) {
    // const [start, end] = dates;

    const start = dates[0];
    let end = dates[1];
    const today = new Date();

    // Cap future end date
    if (end && end > today) {
      end = today;
    }

    // Normalize the dates
    const normalizedStartDate = getStartOfDay(start);
    const normalizedEndDate = getEndOfDay(end);

    dispatch(setDateRange(normalizedStartDate, normalizedEndDate));
  }
};

  CustomDate.propTypes = {
    value: PropTypes.string,
    onClick: PropTypes.func,
    className: PropTypes.string,
    startDate: PropTypes.instanceOf(Date),
    endDate: PropTypes.instanceOf(Date),
  };

  return (
    <Box>
      <DatePicker
        selected={startDate}
        maxDate={new Date()}
        onChange={handleDateChange}
        startDate={startDate}
        endDate={endDate}
        selectsRange
        customInput={<CustomDate startDate={startDate} endDate={endDate} />}
      />
    </Box>
  );
};
export default CustomDateInput;
